import React from 'react'
import Ellipse from '../../images/Ellipse'

const SearchAutocompleteLoading = ({ className = '' }) => (
  <div
    className={`search-autocomplete-loading flex size-full place-items-center justify-center ${className}`}
  >
    <Ellipse className="animate-spin" />
  </div>
)
export default SearchAutocompleteLoading
